import {
  Button,
  Modal,
  Form,
  Input,
  Row,
  Col,
  Select,
  Upload,
  message,
  Switch,
  Card,
  Image,
} from "antd";
import {
  MailOutlined,
  UserOutlined,
  UsergroupAddOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { getBase64, beforeUpload } from "../../../utils/handlePhoto";
import API from "../../../services/api-request";
import { baseUrl } from "../../../config/url-config";
import { getDataLogin } from "../../../utils/getDataLogin";
import state from "../../../config/valtio/store";
import SelectRFID from "../../../components/SelectRFID";

const Profile = () => {
  const [privilege, setPrivilege] = useState(0);
  const [editForm] = Form.useForm();
  const [changePassword, setChangePassword] = useState(false);
  const [optionsPrivilege, setOptionsPrivilege] = useState([]);
  const [loadingButton, setLoadingButton] = useState(false);

  const onFinish = async (values) => {
    setLoadingButton(true);
    const { name, email, username, password, id_privilege, image, rfid_id } =
      values;
    let dataForm = {};

    dataForm = {
      name,
      email,
      username,
      password: password ?? "",
      id_privilege: id_privilege ?? getDataLogin()?.id_privilege,
      image,
      id: getDataLogin().id,
    };

    if (privilege === 6 && getDataLogin().id_privilege === 6) {
      dataForm.rfid_id = rfid_id;
    }

    const formData = new FormData();

    for (const property in dataForm) {
      formData.append(`${property}`, dataForm[property]);
    }

    await API.Post("user/update", formData)
      .then(async () => {
        await API.Get(`user/id_user/${getDataLogin().id}`)
          .then((result) => {
            message.success("profile has been saved");
            updateLocalStorage(result);
            setChangePassword(false);
            setLoadingButton(false);
          })
          .catch((err) => {
            setLoadingButton(false);
            message.info(`${err?.response?.data?.error}`);
          });
      })
      .catch((err) => {
        setLoadingButton(false);
        message.info(`${err?.response?.data?.error}`);
      });
  };

  const updateLocalStorage = (apiResponse) => {
    // Step 1: Retrieve the existing localStorage data
    const existingData = JSON.parse(localStorage.getItem("data-login")) || {};

    // Step 2: Access the nested token
    const token = existingData?.data?.data?.token;

    // Step 3: Merge the new API response while preserving the token
    const updatedData = {
      ...existingData, // Keep existing structure
      data: {
        ...existingData.data, // Preserve existing `data`
        ...apiResponse, // Add/overwrite fields from API response
        data: {
          ...existingData.data?.data, // Preserve nested data
          ...apiResponse.data, // Overwrite with new data
          token, // Ensure the token remains unchanged
        },
      },
    };

    // Step 4: Save the updated structure back to localStorage
    localStorage.setItem("data-login", JSON.stringify(updatedData));

  };

  const getPrivilege = async () => {
    state.LOADING = true;

    await API.Get("privilege")
      .then((result) => {
        setOptionsPrivilege(
          result?.data?.map((e) => ({ value: e.id, label: e.name }))
        );
      })
      .catch((err) => {
        console.error(err);
        message.info("Failed Fetch Privilege Data!");
      });

    state.LOADING = false;
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  // File Upload Variable & Function
  const [fileList, setFileList] = useState([]);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };
  const handleChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };
  const dummyRequest = ({ onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };
  const getFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }

    return e?.file?.originFileObj;
  };

  useEffect(() => {
    setPrivilege(getDataLogin().id_privilege);
    getPrivilege();
    editForm.setFieldsValue(getDataLogin());
    setFileList([
      {
        url: `${baseUrl}/${getDataLogin().image}`,
      },
    ]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Row gutter={[24, 24]}>
        <Col lg={8} md={10} xs={24}>
          <Card variant="outlined">
            <Row
              justify={"center"}
              gutter={[16, 16]}
              style={{ flexDirection: "column" }}
              align={"middle"}
            >
              <Image
                style={{
                  borderRadius: 180,
                  display: "block",
                  margin: "auto",
                }}
                width={180}
                height={180}
                fallback="data:image/png;base64,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"
                src={`${baseUrl}/${getDataLogin()?.image}`}
              ></Image>
              <div style={{ fontWeight: 700, alignContent: "center" }}>
                {getDataLogin().name}
              </div>
              <Card variant="outlined" style={{ width: "100%" }}>
                <Row align={"middle"}>
                  <Col lg={2} xs={4}>
                    <MailOutlined />
                  </Col>
                  <Col lg={10} xs={20}>
                    <div style={{ fontWeight: 600, alignContent: "center" }}>
                      Email
                    </div>
                  </Col>
                  <Col lg={10} xs={24}>
                    <div style={{ fontWeight: 600, alignContent: "center" }}>
                      {getDataLogin().email}
                    </div>
                  </Col>
                </Row>
              </Card>
              <Card variant="outlined" style={{ width: "100%" }}>
                <Row align={"middle"}>
                  <Col lg={2} xs={4}>
                    <UserOutlined />
                  </Col>
                  <Col lg={10} xs={20}>
                    <div style={{ fontWeight: 600, alignContent: "center" }}>
                      Username
                    </div>
                  </Col>
                  <Col lg={10} xs={24}>
                    <div style={{ fontWeight: 600, alignContent: "center" }}>
                      {getDataLogin().username}
                    </div>
                  </Col>
                </Row>
              </Card>
              <Card variant="outlined" style={{ width: "100%" }}>
                <Row align={"middle"}>
                  <Col lg={2} xs={4}>
                    <UsergroupAddOutlined />
                  </Col>
                  <Col lg={10} xs={20}>
                    <div style={{ fontWeight: 600, alignContent: "center" }}>
                      Privilege
                    </div>
                  </Col>
                  <Col lg={10} xs={24}>
                    <div style={{ fontWeight: 600, alignContent: "center" }}>
                      {getDataLogin().privilege?.name}
                    </div>
                  </Col>
                </Row>
              </Card>
            </Row>
          </Card>
        </Col>
        <Col lg={16} md={14} xs={24}>
          <Card variant="outlined">
            <Form
              form={editForm}
              name="Edit Form"
              style={{
                margin: "0 auto",
              }}
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Row gutter={16}>
                <Col lg={12} xs={24}>
                  <Form.Item
                    label="Name"
                    name="name"
                    rules={[
                      { required: true, message: "Please input your name!" },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col lg={12} xs={24}>
                  <Form.Item
                    label="Email"
                    name="email"
                    rules={[
                      { required: true, message: "Please input your email!" },
                      {
                        type: "email",
                        message: "The input is not a valid email address!",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col lg={24} xs={24}>
                  <Switch
                    size="small"
                    onChange={() => setChangePassword(!changePassword)}
                    checked={changePassword}
                  />
                </Col>
                <Col lg={12} xs={24}>
                  <Form.Item
                    label="Change Password"
                    name="password"
                    rules={[
                      {
                        required: false,
                        message: "Please input your password!",
                      },
                    ]}
                  >
                    <Input.Password disabled={!changePassword} />
                  </Form.Item>
                </Col>
                <Col lg={12} xs={24}>
                  <Form.Item
                    label="Confirm Password"
                    name="password2"
                    dependencies={["password"]}
                    rules={[
                      { required: false },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value || getFieldValue("password") === value) {
                            return Promise.resolve();
                          }
                          return Promise.reject(
                            new Error(
                              "The new password that you entered do not match!"
                            )
                          );
                        },
                      }),
                    ]}
                  >
                    <Input.Password disabled={!changePassword} />
                  </Form.Item>
                </Col>
                <Col lg={12} xs={24}>
                  <Form.Item
                    label="Username"
                    name="username"
                    rules={[
                      {
                        required: true,
                        message: "Please input your username!",
                      },
                    ]}
                  >
                    <Input
                      readOnly={getDataLogin().privilege?.name !== "admin"}
                    />
                  </Form.Item>
                </Col>
                {getDataLogin()?.id_privilege !== 3 &&
                  getDataLogin()?.privilege?.name?.toLowerCase() !== "client" ? (
                  <Col lg={12} xs={24}>
                    <Form.Item
                      label="Privilege"
                      name="id_privilege"
                      rules={[
                        {
                          required: true,
                          message: "Please input your privilege!",
                        },
                      ]}
                    >
                      <Select options={optionsPrivilege} />
                    </Form.Item>
                  </Col>
                ) : null}
                {privilege === 6 && getDataLogin().id_privilege === 6 ? (
                  <>
                    <Col lg={12} md={12} sm={12} xs={24}>
                      <Form.Item
                        label="No. RFID"
                        name="rfid_id"
                        rules={[
                          { required: true, message: "Please input No. RFID!" },
                        ]}
                      >
                        <SelectRFID />
                      </Form.Item>
                    </Col>
                    <Col lg={12} md={12} sm={12} xs={24}></Col>
                  </>
                ) : null}
                <Col lg={12} xs={24}>
                  <Row>
                    <Col lg={12} xs={24}>
                      <Form.Item
                        label="Upload Photo"
                        name="image"
                        getValueFromEvent={getFile}
                      >
                        <Upload
                          maxCount={1}
                          customRequest={dummyRequest}
                          listType="picture-card"
                          fileList={fileList}
                          beforeUpload={beforeUpload}
                          onPreview={handlePreview}
                          onChange={handleChange}
                        >
                          {fileList.length >= 1 ? null : (
                            <button
                              style={{ border: 0, background: "none" }}
                              type="button"
                            >
                              <PlusOutlined />
                              <div style={{ marginTop: 8 }}>Upload</div>
                            </button>
                          )}
                        </Upload>
                      </Form.Item>
                    </Col>
                    <Col lg={12} xs={24}>
                      <ul style={{ fontSize: "10px" }}>
                        <li>Must be {"<"} 2MB!</li>
                        <li>Must be JPEG/PNG</li>
                      </ul>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Button
                loading={loadingButton}
                htmlType="submit"
                style={buttonStyle}
                type="primary"
              >
                Save
              </Button>
            </Form>
          </Card>
        </Col>
      </Row>
      <Modal
        open={previewOpen}
        footer={null}
        onCancel={() => setPreviewOpen(false)}
      >
        <Image
          style={{
            display: "block",
            margin: "auto",
          }}
          width={"100%"}
          fallback="data:image/png;base64,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"
          src={previewImage}
          preview={false}
        ></Image>
      </Modal>
    </>
  );
};

const buttonStyle = {
  width: "100%",
};



Profile.propTypes = {

};

export default Profile;
